import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';

export const Container = styled(Row)`
  width: 100%;
  height: 56px;
  padding: 10px 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.columnHeaders};
  z-index: 2;
`;

export const CloseButton = styled(Row)`
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 34px;
  width: 34px;
  opacity: 0.65;

  &:hover {
    opacity: 1;
  }

  svg {
    outline: none;
  }
`;

export const Content = styled(Row)`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const ActionText = styled(Text14)`
  cursor: pointer;
`;
